import React from 'react';

import { Select } from 'semantic-ui-react';

import { REVIEW_RESPONSE_STATUS_OPTIONS } from '../../constants';

export default function StatusSelector({ value, onChange }) {
  return (
    <Select
      style={{ width: '100%' }}
      selection
      options={REVIEW_RESPONSE_STATUS_OPTIONS}
      value={value}
      onChange={(e, { value: v }) => onChange(v)}
      placeholder="Filter by Status"
    />
  );
}
